import { Button } from '@cian/ui-kit';
import { useDispatch, useSelector } from 'react-redux';
import { useDeviceType } from '@cian/ui-kit/responsive/hooks/useDeviceType';

import { NewReviewModalFooter } from '../../components/NewReviewModal/parts/NewReviewModalFooter';
import { goToNextStep, goToPrevStep } from '../../actions/newReview';
import { selectIsCurrentStepValid, selectIsPrevStepAvailable } from '../../selectors/newReview';
import { TThunkDispatch } from '../../types/redux';

export const NewReviewModalFooterContainer = () => {
  const deviceType = useDeviceType();
  const dispatch = useDispatch<TThunkDispatch>();
  const isNextStepAvailable = useSelector(selectIsCurrentStepValid);
  const isPrevStepAvailable = useSelector(selectIsPrevStepAvailable);
  const isMobile = deviceType === 'phone';

  const onNextClick = () => {
    dispatch(goToNextStep());
  };

  const onPrevClick = () => {
    dispatch(goToPrevStep());
  };

  return (
    <NewReviewModalFooter
      next={
        <Button
          data-testid="nextstep"
          fullWidth={isMobile}
          size={isMobile ? 'M' : 'XS'}
          disabled={!isNextStepAvailable}
          onClick={onNextClick}
        >
          Продолжить
        </Button>
      }
      prev={
        isPrevStepAvailable ? (
          <Button
            data-testid="prevstep"
            fullWidth={isMobile}
            size={isMobile ? 'M' : 'XS'}
            theme={isMobile ? 'fill_secondary' : 'fill_white_primary'}
            onClick={onPrevClick}
          >
            Назад
          </Button>
        ) : null
      }
    />
  );
};
